'use client';

import React from 'react';
import { ServicesData } from '@sapientpro/sapientpro-data-models';
import styles from './Service.module.scss';
import Button, { ButtonVariants } from '../../../../components/Button';

interface IProps {
  service: ServicesData;
  serviceTitle: string;
  serviceDescription: string;
}

const Service = ({ serviceTitle, service, serviceDescription }: IProps) => (
  <div className={styles.service}>
    <div className={styles.info}>
      <h4 className={styles.title}>
        {serviceTitle}
      </h4>
      <p className={styles.description}>{serviceDescription}</p>
      {service && (
      <Button
        link={`/${service?.slug}`}
        className={styles.viewButton}
        variant={ButtonVariants.TRANSPARENT}
        icon={(
          <svg>
            <use
              xlinkHref='/media/arrow-right-bold.svg#arrowRight'
              href='/media/arrow-right-bold.svg#arrowRight'
            />
          </svg>
          )}
        iconPosition='right'
        iconSize={{ width: 24, height: 24 }}
      >
        Learn More
      </Button>
      )}
    </div>
    <ul className={styles.links}>
      {service?.subservices?.map((subservice) => {
        const displayedTitle = subservice.previewTitle || subservice.formattedTitle || subservice.title;

        return (
          <li key={subservice.id}>
            <a
              href={`/${subservice.slug}`}
              className={styles.link}
            >
              {displayedTitle}
              <svg>
                <use
                  xlinkHref='/media/arrow-right-bold.svg#arrowRight'
                  href='/media/arrow-right-bold.svg#arrowRight'
                />
              </svg>
            </a>
          </li>
        );
      })}
    </ul>
  </div>
);

export default Service;
